export const TAG_MEETINGS = 'Meetings';
export const TAG_RACES = 'Races';
export const TAG_RACE = 'Race';
export const TAG_RACE_PREVIEW = 'RacePreview';
export const TAG_RUNNERS = 'Runners';
export const TAG_ODDS = 'Odds';
export const TAG_FIXED_ODDS = 'FixedOdds';
export const TAG_USER = 'User';
export const TAG_PARTNERS = 'Partners';
export const TAG_LOGOUT = 'Logout';
export const TAG_EVENTS = 'Events';
export const TAG_RACE_TIPS = 'RaceTips';
export const TAG_EDITORIAL_CONTENTS = 'EditorialContents';
export const TAG_PERFORMANCES = 'Performances';
